import { combineReducers } from 'redux'
import addOrEdit from './addOrEdit'
import tasksByID from './tasksByID'
import typesByID from './typesByID'
import viewSelected from './viewSelected'
import sort from './sort'
import schema from './schema'
import schedulerMounted from './schedulerMounted'
import viewManuallySelected from './viewManuallySelected'

export default combineReducers({
  addOrEdit,
  tasksByID,
  typesByID,
  viewSelected,
  schema,
  sort,
  schedulerMounted,
  viewManuallySelected,
})
